import React, { useContext, useEffect, useRef, useState } from "react";
import AdminLayout from "../../layouts/AdminLayout";
import { useParams } from "react-router-dom";
import { decryptData } from "../../utils/encryptDecrypt";
import Spinner from "../../components/common/Spinner";
import api, { API_BASE_URL, fetchData } from "../../api/api";
import { toast } from "react-toastify";
import { CONSTANT_REDIRECT_TIME } from "../../constant/common";
import { getInitials } from "../../utils/helper";
import { formatDateForView } from "../../utils/formateDate";


const AdminReviewsList = () => {
    const { practices_id } = useParams();

    const decrypted_practices_id = decryptData(practices_id);

    const didFetch = useRef(false);

    const [isLoading, setIsLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);

    const [reviews, setReviewsList] = useState([]);

    const [isReply, setIsReply] = useState(false);

    const [selectedReview, setSelectedReview] = useState(null);

    const [replyMessage, setReplyMessage] = useState(null);

    const getReviews = async () => {
        if (decrypted_practices_id) {
            setIsLoading(true);
            try {
                const data = await fetchData('/get-reviews', {
                    fk_practices_id: decrypted_practices_id
                });
                setReviewsList(data);
                setCurrentPage(1);

                setIsReply(false);
                setReplyMessage(null);
                setSelectedReview(null);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
            getReviews();
            didFetch.current = true;
        }
    }, []);

    const itemsPerPage = 10;

    const totalPages = Math.ceil(reviews.length / itemsPerPage);

    const paginatedData = reviews?.length > 0 ? reviews.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    ) : [];

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const handleSubmitReview = async (e) => {
        e.preventDefault();

        try {
            const response = await api.post("add-reviews-reply", {
                practices_reviews_id: selectedReview?.practices_reviews_id,
                reply: replyMessage
            });

            if (response?.data?.status === true) {
                toast.success(response.data?.message);

                setTimeout(() => {
                    getReviews();
                }, CONSTANT_REDIRECT_TIME);

            } else {
                toast.error(response?.data?.message || "Failed ");
                return null;
            }
        } catch (error) {
            console.error("Error :", error);
            toast.error("Something went wrong. Please try again.");
            return null;
        }
    }

    if (isLoading) {
        return (<Spinner adminLayout={true} />);
    }

    return (
        <AdminLayout>
            <main>
                <div className="container mx-auto px-3">
                    <div className="py-4 sm:py-6 md:py-7 flex justify-between items-center gap-2 ">
                        <h1 className="font-semibold text-lg sm:text-2xl">View All Reviews</h1>
                    </div>

                    {paginatedData?.length > 0 ? paginatedData?.map((item, index) => (
                        <div key={index} className="p-[18px] border border-solid border-[#bbb] rounded-2xl mb-3">
                            <div className="flex gap-3 justify-between items-center flex-wrap mb-3">
                                <div className="flex gap-3 items-center">
                                    <div className="rounded-full h-12 w-12 flex items-center justify-center bg-gray-400 text-white font-semibold text-lg overflow-hidden">
                                        {getInitials(item?.name)}
                                    </div>
                                    <div>
                                        <h3 className="text-dark font-semibold text-base">{item?.name}</h3>
                                        <p className="text-dark font-normal text-xs">{formatDateForView(item?.created_date)}</p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => {
                                        setIsReply(true);
                                        setSelectedReview(item);
                                        setReplyMessage(item?.reply ? item?.reply : null)
                                    }}
                                    type="button"
                                    className="text-blue text-base font-medium underline flex items-center ml-auto reviewreplaybtn">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.0005 7.70833H4.84219L7.10885 5.44166C7.35052 5.19999 7.35052 4.79999 7.10885 4.55833C6.86719 4.31666 6.46719 4.31666 6.22552 4.55833L2.89219 7.89166C2.65052 8.13333 2.65052 8.53333 2.89219 8.77499L6.22552 12.1083C6.35052 12.2333 6.50885 12.2917 6.66719 12.2917C6.82552 12.2917 6.98385 12.2333 7.10885 12.1083C7.35052 11.8667 7.35052 11.4667 7.10885 11.225L4.84219 8.95833H10.0005C12.4172 8.95833 14.3755 10.925 14.3755 13.3333V15C14.3755 15.3417 14.6589 15.625 15.0005 15.625C15.3422 15.625 15.6255 15.3417 15.6255 15V13.3333C15.6255 10.2333 13.1005 7.70833 10.0005 7.70833Z" fill="#0052CC"></path>
                                    </svg>
                                    {item?.reply == null ? 'Reply' : 'Edit'}
                                </button>
                            </div>
                            <div className="flex gap-1 mb-3">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <img
                                        key={star}
                                        src={item.rate >= star ? "/assets/image/star.svg" : "/assets/image/balnkstar.svg"}
                                        alt={`Star ${star}`}
                                    />
                                ))}
                            </div>
                            <p className="text-sm text-dark font-normal text-justify mb-3">
                                {item?.message}
                            </p>
                            {/* {item?.reply != null &&
                                <p className="text-sm text-dark font-normal text-justify mb-3 ml-8 mt-4">{item?.reply}</p>
                            } */}

                            {item?.reply != null && (
                                <div className="flex justify-start mt-6">
                                    <div className="rounded-xl">
                                        <div className="flex items-center justify-start gap-2 mb-3">

                                            <div className="rounded-full h-12 w-12 flex items-center justify-center bg-gray-400 text-white font-semibold text-lg overflow-hidden">
                                                You
                                            </div>
                                            <div>
                                                <h3 className="text-dark font-semibold text-base">Your Reply</h3>
                                                <p className="text-dark font-normal text-xs">{formatDateForView(item?.reply_date)}</p>
                                            </div>
                                        </div>
                                        <p className="text-sm text-dark font-normal">{item?.reply}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))
                        : <p>No reviews found.</p>}
                </div>

                {paginatedData?.length > 0 && (
                    <div className="container mx-auto px-3 py-3">
                        <ul className="flex items-center -space-x-px h-10 text-base justify-end">
                            {/* Previous Button */}
                            <li>
                                <button
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                    className={`flex items-center justify-center px-4 h-10 ms-0 leading-tight border border-e-0 rounded-s-lg border-[#73aeff] 
          ${currentPage === 1 ? "text-gray-400 bg-gray-200 cursor-not-allowed" : "text-blue bg-gray-200 hover:bg-gray-100"}`}
                                >
                                    <svg className="w-3 h-3 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 1 1 5l4 4"></path>
                                    </svg>
                                </button>
                            </li>

                            {/* Dynamic Pagination Logic */}
                            {Array.from({ length: totalPages }, (_, i) => i + 1)
                                .filter((page) => {
                                    return (
                                        page === 1 ||
                                        page === totalPages ||
                                        (page >= currentPage - 1 && page <= currentPage + 1)
                                    );
                                })
                                .reduce((acc, page, index, arr) => {
                                    if (index > 0 && page !== arr[index - 1] + 1) {
                                        acc.push("...");
                                    }
                                    acc.push(page);
                                    return acc;
                                }, [])
                                .map((page, index) => (
                                    <li key={index}>
                                        {page === "..." ? (
                                            <span className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] bg-gray-200 text-blue`}>...</span>
                                        ) : (
                                            <button
                                                onClick={() => handlePageChange(page)}
                                                className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] 
                ${currentPage === page ? "bg-white text-blue" : "bg-gray-200 text-blue hover:bg-gray-100"}`}
                                            >
                                                {page}
                                            </button>
                                        )}
                                    </li>
                                ))}

                            {/* Next Button */}
                            <li>
                                <button
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                    className={`flex items-center justify-center px-4 h-10 leading-tight border rounded-e-lg border-[#73aeff] 
          ${currentPage === totalPages ? "text-gray-400 bg-gray-200 cursor-not-allowed" : "text-blue bg-gray-200 hover:bg-gray-100"}`}
                                >
                                    <svg className="w-3 h-3 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"></path>
                                    </svg>
                                </button>
                            </li>
                        </ul>
                    </div>
                )}

                <div id="reviewreplay" class={`fixed bg-[#0000007A] top-0 left-0 h-screen w-full z-[999] justify-center items-center px-3 ${isReply ? 'flex' : 'hidden'}`}>
                    <div className="max-w-[648px] w-full mx-auto bg-white rounded-xl sm:rounded-2xl px-5 py-3 sm:px-8 sm:py-6 md:px-11 md:py-8 innercard relative">
                        <button onClick={() => {
                            setReplyMessage(null)
                            setIsReply(false)
                            setSelectedReview(null)
                        }} type="button" className="absolute right-4 top-4">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M0.41791 0.436139C0.685579 0.168311 1.04857 0.0178675 1.42704 0.0178675C1.80551 0.0178675 2.1685 0.168311 2.43617 0.436139L9.99103 7.99754L17.5459 0.436139C17.6777 0.299682 17.8351 0.190853 18.0092 0.115982C18.1834 0.0411107 18.3708 0.00171073 18.5602 5.3593e-05C18.7497 -0.00158926 18.9377 0.0345535 19.1131 0.106382C19.2886 0.17821 19.4479 0.284296 19.5819 0.418424C19.7159 0.552553 19.822 0.712052 19.8938 0.887623C19.9654 1.06319 20.0015 1.25131 19.9999 1.44099C19.9982 1.63068 19.9588 1.81814 19.884 1.99242C19.8093 2.16671 19.7005 2.32435 19.5642 2.45612L12.0093 10.0175L19.5642 17.5789C19.8242 17.8484 19.9681 18.2092 19.9648 18.5838C19.9616 18.9584 19.8115 19.3167 19.5468 19.5815C19.2821 19.8464 18.9242 19.9967 18.5499 19.9999C18.1757 20.0032 17.8151 19.8592 17.5459 19.5989L9.99103 12.0375L2.43617 19.5989C2.16697 19.8592 1.80643 20.0032 1.43218 19.9999C1.05793 19.9967 0.699938 19.8464 0.435296 19.5815C0.170653 19.3167 0.0205397 18.9584 0.0172997 18.5838C0.0140454 18.2092 0.157906 17.8484 0.41791 17.5789L7.97277 10.0175L0.41791 2.45612C0.150327 2.18824 0 1.82494 0 1.44612C0 1.06732 0.150327 0.704024 0.41791 0.436139Z" fill="black"></path>
                            </svg>
                        </button>
                        <h3 className="text-xl text-dark font-semibold mb-3">Reply Review</h3>
                        <form onSubmit={handleSubmitReview} action="">
                            <textarea required name="" onChange={(e) => setReplyMessage(e.target.value)}
                                value={replyMessage || ""}
                                id="description" placeholder="Description" className="border-[1.2px] border-dark w-full rounded-xl py-4 px-4 sm:px-7 focus:border-blue outline-none text-base sm:text-xl min-h-56 mb-4 sm:mb-6 md:mb-8" spellcheck="false">
                            </textarea>
                            <button type="submit" id="register" className="h-auto py-3 px-3 sm:h-14 md:h-[66px] bg-blue w-full text-center text-white font-semibold text-lg sm:text-2xl rounded-xl mb-5 sm:mb-[30px]">Send Reply</button>
                        </form>
                    </div>
                </div>

                <div id="googlereviews" className="fixed bg-[#0000007A] top-0 left-0 h-screen w-full z-[999] hidden justify-center items-center px-3">
                    <div className="max-w-[648px] w-full mx-auto bg-white rounded-xl sm:rounded-2xl px-5 py-3 sm:px-8 sm:py-6 md:px-11 md:py-8 innercard">
                        <div className="grid grid-cols-2 gap-y-4 gap-x-[20px] lg:gap-x-[30px]">
                            <div className="col-span-2">
                                <label for="email" className="mb-2 inline-block text-dark font-semibold text-base sm:text-xl">Email Id</label>
                                <input type="email" name="email" id="email" className="border-[1.2px] border-dark w-full h-12 sm:h-14 rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl" placeholder="Enter your email" />
                            </div>
                            <div className="col-span-2">
                                <label for="createpassword" className="mb-2 inline-block text-dark font-semibold text-base sm:text-xl">Password</label>
                                <div className="relative">
                                    <input type="password" name="" id="createpassword" className="password-input border-[1.2px] border-dark w-full h-12 sm:h-14 rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl" placeholder="Enter your password" />
                                    <a href="#" className="password-toggle absolute top-1/2 right-5 -translate-y-2/4">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62283 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87993 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z" fill="#393939"></path>';
                                        </svg>
                                    </a>
                                </div>
                            </div>
                            <div className="col-span-2">
                                <button type="submit" className="h-auto py-3 px-3 sm:h-14 bg-blue w-full text-center text-white font-semibold text-lg sm:text-2xl rounded-xl sm:mt-4">Import Google Reviews</button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </AdminLayout>
    )
}

export default AdminReviewsList